import { taskDelegateIds } from './workflowTaskUtils';

const htmlToText = (value) => String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

export const liveTrackingSourceSignature = (item, task, message) => {
  if (item?.itemType === 'TASK' && task) {
    return [
      task.status || task.statusString || '',
      task.updatedAt || '',
      task.completionPercentage ?? '',
      task.title || '',
      (taskDelegateIds(task) || []).join(','),
    ].join('|');
  }
  if (item?.itemType === 'WORKFLOW' && message) {
    const payload = message.payloadJson && typeof message.payloadJson === 'string'
      ? (() => { try { return JSON.parse(message.payloadJson); } catch { return {}; } })()
      : {};
    const reactions = (message.reactions || payload.reactions || [])
      .map((row) => row.emoji || row.reactionId || row.id || '')
      .join(',');
    return [
      message.updatedAt || '',
      message.workflowAssignedToUserId || payload.workflowAssignedToUserId || '',
      htmlToText(message.content || payload.content),
      reactions,
      message.urgentDeadlineAt || message.urgentDeadline || payload.urgentDeadlineAt || '',
    ].join('|');
  }
  return '';
};

export const normalizeLiveTrackingItem = (item) => {
  if (!item || typeof item !== 'object') return item;
  const id = item.id || item._id;
  return {
    ...item,
    id,
    _id: id,
    boardLane: String(item.boardLane || 'TEAM').toUpperCase(),
    sortOrder: Number(item.sortOrder) || 0,
  };
};

const stripHtml = (value) => String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

export const liveTrackingCommentPreview = (message) => {
  const text = stripHtml(message?.content);
  return text || (Array.isArray(message?.attachments) && message.attachments.length ? 'Attachment' : 'New comment');
};

export const matchLiveTrackingItemForMessage = (items, message, channels = []) => {
  if (!message || !Array.isArray(items) || !items.length) return null;
  const replyTo = message.replyToMessageId ? String(message.replyToMessageId) : '';
  const messageId = message.id ? String(message.id) : '';
  const taskId = message.taskId ? String(message.taskId) : '';
  const channelId = message.channelId ? String(message.channelId) : '';
  const channel = (channels || []).find((row) => String(row.id) === channelId);
  const threadKey = String(channel?.systemChannelKey || '');
  const threadTaskId = threadKey.startsWith('TASK_THREAD:') ? threadKey.slice('TASK_THREAD:'.length) : '';

  return items.find((item) => {
    if (!item || item.itemType === 'NOTE') return false;
    if (item.itemType === 'TASK') {
      if (taskId && String(item.taskId) === taskId) return true;
      if (threadTaskId && String(item.taskId) === threadTaskId) return true;
      if (replyTo && String(item.sourceMessageId) === replyTo) return true;
      return false;
    }
    if (item.itemType === 'WORKFLOW') {
      const source = String(item.sourceMessageId || '');
      if (!source) return false;
      if (messageId === source) return false;
      if (replyTo === source) return true;
      if (String(message.workflowTrackId || '') && String(message.workflowTrackId) === String(item.sourceKey || '')) {
        return true;
      }
      return false;
    }
    return false;
  }) || null;
};
